import { Helper } from '@/mixin/helper'
import store from '@/state/store'
import customerContract from './customer-contract'

export default [
  // Master Home New
  {
    path: '/master/',
    name: 'Master Home Page',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'd1a-default-mdkendaraan:read',
            'd2a-default-mdpelacak:read',
            'd3a-default-mdalamat:read',
            'd4a-default-mdpengguna:read',
            'd5a-default-mdkaryawan:read',
            'd7a-default-md-route:read',
            'tms:read',
            'vms:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/index-v2'),
  },

  // Master Home Page - Deprecated
  {
    path: '/master-deprecated/',
    name: 'Master Home Page Deprecated',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'd1a-default-mdkendaraan:read',
            'd2a-default-mdpelacak:read',
            'd3a-default-mdalamat:read',
            'd4a-default-mdpengguna:read',
            'd5a-default-mdkaryawan:read',
            'tms:read',
            'vms:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master'),
  },

  // Master Fleet
  {
    path: '/master/fleet/',
    name: 'Master Fleet',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll'](['vehicles:read', 'd1a-default-mdkendaraan:read'])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/fleet'),
  },
  {
    path: '/master/fleet/create/',
    name: 'Master Fleet Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'vehicles:create',
            'vehicle_audit_logs:read',
            'vehicle_categories:read',
            'devices:read',
            'd1a-default-mdkendaraan:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/fleet/form'),
  },
  {
    path: '/master/fleet/update/:id',
    name: 'Master Fleet Update',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        if (
          store.getters['identity/hasAccessAll']([
            'vehicles:update',
            'vehicle_audit_logs:read',
            'vehicle_categories:read',
            'devices:read',
            'd1a-default-mdkendaraan:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/fleet/form'),
  },
  {
    path: '/master/fleet/update/history/:id',
    name: 'Master Fleet Update History',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'vehicles:read',
            'vehicle_audit_logs:read',
            'd1a-default-mdkendaraan:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/fleet/UpdateHistory'),
  },

  // Master Tracking
  {
    path: '/master/tracking/',
    name: 'Master Tracking',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll'](['devices:read', 'd2a-default-mdpelacak:read'])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/tracking'),
  },

  // Master Service
  {
    path: '/master/service/',
    name: 'Master Service',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/service'),
  },

  {
    path: '/master/service/maintenance/addservice',
    name: 'Add Master Service Maintenance',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/service/maintenance/form'),
  },

  {
    path: '/master/service/maintenance/updateservice/:id',
    name: 'Update Master Service Maintenance',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/service/maintenance/form'),
  },

  {
    path: '/master/service/sparepartsadd',
    name: 'Service Spare Part Add',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/service/parts/FormParts'),
  },

  {
    path: '/master/service/sparepartsupdate/:id',
    name: 'Service Spare Part Update',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/service/parts/FormParts'),
  },

  // Master Address
  {
    path: '/master/address/',
    name: 'Master Address',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll'](['geofences:read', 'd3a-default-mdalamat:read'])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/address'),
  },
  {
    path: '/master/address/create/',
    name: 'Master Address Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll'](['geofences:create', 'd3a-default-mdalamat:read'])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/address/form'),
  },
  {
    path: '/master/address/update/:id',
    name: 'Master Address Update',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        if (
          store.getters['identity/hasAccessAll'](['geofences:update', 'd3a-default-mdalamat:read'])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/address/form'),
  },

  {
    path: '/master/address/import/',
    name: 'Master Address Import',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll'](['geofences:create', 'd3a-default-mdalamat:read'])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/address/ImportPage'),
  },

  {
    path: '/master/address/importresult/',
    name: 'Master Address Import Result',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll'](['geofences:create', 'd3a-default-mdalamat:read'])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/address/ImportResultPage'),
  },

  // Master Customer
  {
    path: '/master/customer/',
    name: 'Master Customer',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'tms:create',
            'tms:read',
            'tms:update',
            'tms:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/customer'),
  },

  {
    path: '/master/customer/create/',
    name: 'Master Customer Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'tms:create',
            'tms:read',
            'tms:update',
            'tms:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/customer/form'),
  },

  {
    path: '/master/customer/update/:id',
    name: 'Master Customer Update',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'tms:create',
            'tms:read',
            'tms:update',
            'tms:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/customer/form'),
  },

  {
    path: '/master/customer/update/:uuid/address/',
    name: 'Master Customer Create Address',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'tms:create',
            'tms:read',
            'tms:update',
            'tms:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/customer/address'),
  },

  {
    path: '/master/customer/update/:uuid/address/:id',
    name: 'Master Customer Update Address',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'tms:create',
            'tms:read',
            'tms:update',
            'tms:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/customer/address'),
  },

  {
    path: '/master/customer/import',
    name: 'Master Customer Import',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'tms:create',
          'tms:read',
          'tms:update',
          'tms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/customer/import'),
    children: [
      {
        path: '',
        name: 'Master Customer Import',
        component: () => import('@/router/views/master/customer/import/contents/Upload.vue'),
      },
      {
        path: ':id',
        name: 'Master Customer Import Detail',
        component: () => import('@/router/views/master/customer/import/contents/Process.vue'),
      },
      {
        path: ':id/result',
        name: 'Master Customer Import Result',
        component: () => import('@/router/views/master/customer/import/contents/Result.vue'),
      },
    ],
  },

  // Master Employee
  {
    path: '/master/employee/',
    name: 'Master Employee',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccessAll'](['users:read', 'd5a-default-mdkaryawan:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/employee'),
  },

  // Master Create Employee
  {
    path: '/master/employee/create/',
    name: 'Master Employee Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll'](['users:create', 'd5a-default-mdkaryawan:read'])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/employee/form'),
  },

  // Detail Master Employee Detail
  {
    path: '/master/employee/employeedetail/:id',
    name: 'Master Employee Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll'](['users:update', 'd5a-default-mdkaryawan:read'])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/employee/form'),
  },

  // Detail Master Employee Detail Riwayat Perjalanan
  {
    path: '/master/employee/employeehistorydriver/:id',
    name: 'Riwayat Perjalanan Pengemudi',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'users:update',
            'd5a-default-mdkaryawan:read',
            'last_summary_trip_driver:read',
            'summary_trip_driver:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "master" */ '@/router/views/master/employee/employeehistorydriver'
      ),
  },

  {
    path: '/master/employee/import/',
    name: 'Master Employee Import',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll'](['users:create', 'd5a-default-mdkaryawan:read'])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/employee/ImportPage'),
  },

  {
    path: '/master/employee/importresult/',
    name: 'Master Employee Import Result',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll'](['users:create', 'd5a-default-mdkaryawan:read'])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/employee/ImportResult'),
  },

  // Master User
  {
    path: '/master/user/',
    name: 'Master User',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccessAll'](['users:read', 'd4a-default-mdpengguna:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/user'),
  },

  // Master Vendor
  {
    path: '/master/vendor/',
    name: 'Master Vendor',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'vms:create',
          'vms:read',
          'vms:update',
          'vms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/vendor'),
  },

  {
    path: '/master/vendor/create/',
    name: 'Master Vendor Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'vms:create',
          'vms:read',
          'vms:update',
          'vms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/vendor/form'),
  },

  {
    path: '/master/vendor/:id',
    name: 'Master Vendor Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'vms:create',
          'vms:read',
          'vms:update',
          'vms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/vendor/form'),
  },

  // Master Product
  {
    path: '/master/product/',
    name: 'Master Product',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'tms:create',
          'tms:read',
          'tms:update',
          'tms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/product'),
  },

  {
    path: '/master/product/create/',
    name: 'Master Product Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'tms:create',
          'tms:read',
          'tms:update',
          'tms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/product/form'),
  },

  {
    path: '/master/product/update/:id',
    name: 'Master Product Update',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'tms:create',
          'tms:read',
          'tms:update',
          'tms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/product/form'),
  },

  {
    path: '/master/product/import',
    name: 'Master Product Import',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'tms:create',
          'tms:read',
          'tms:update',
          'tms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/product/import'),
    children: [
      {
        path: '',
        name: 'Master Product Import',
        component: () => import('@/router/views/master/product/import/contents/Upload.vue'),
      },
      {
        path: ':id',
        name: 'Master Product Import Detail',
        component: () => import('@/router/views/master/product/import/contents/Process.vue'),
      },
      {
        path: ':id/result',
        name: 'Master Product Import Result',
        component: () => import('@/router/views/master/product/import/contents/Result.vue'),
      },
    ],
  },

  {
    path: '/master/route/',
    name: 'Master Route',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll'](['geofences:read', 'd7a-default-md-route:read'])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/route'),
  },

  {
    path: '/master/route/create',
    name: 'Master Route Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll'](['geofences:read', 'd7a-default-md-route:create'])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/route/form'),
  },

  {
    path: '/master/route/update/:id',
    name: 'Master Route Update',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll'](['geofences:read', 'd7a-default-md-route:update'])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/route/form'),
  },

  // Master Contract List
  {
    path: '/master/contract/',
    name: 'Master Contract',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, __, next) {
        const hasVMSAccess = store.getters['identity/hasAccessAll']([
          'vms:create',
          'vms:read',
          'vms:update',
          'vms:delete',
        ])
        const hasCustomerContractAccess = store.getters['identity/hasAccessAll']([
          'tms-customer-contract:create',
          'tms-customer-contract:read',
          'tms-customer-contract:update',
          'tms-customer-contract:delete',
          'driver-compatibility:read',
        ])
        if (!hasVMSAccess && !hasCustomerContractAccess) return next({ name: '403' })
        
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/contract/'),
  },

  // Master Customer Contract
  ...customerContract,

  {
    path: '/master/vendor-contract/',
    name: 'Master Vendor Contract',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'vms:create',
          'vms:read',
          'vms:update',
          'vms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/vendor-contract'),
  },

  {
    path: '/master/vendor-contract/create/',
    name: 'Master Vendor Contract Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'vms:create',
          'vms:read',
          'vms:update',
          'vms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/vendor-contract/form'),
  },

  {
    path: '/master/vendor-contract/:vendorId/:contractId/:versionId',
    name: 'Master Vendor Contract Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'vms:create',
          'vms:read',
          'vms:update',
          'vms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/vendor-contract/form'),
  },

  {
    path: '/master/vendor-contract/:vendorId/:contractId/:versionId/addendum-history',
    name: 'Master Vendor Contract Addendum History',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'vms:create',
          'vms:read',
          'vms:update',
          'vms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "master" */ '@/router/views/master/vendor-contract/addendum-history'
      ),
  },

  {
    path: '/master/rfid/',
    name: 'Master RFID',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['z1k-rfid-md:read', 'z1k-rfid-md:update'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/rfid'),
  },

  {
    path: '/master/identification/',
    name: 'Master RFID and Face Recognition',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'd10a-default-rfid&fr:read',
          'd10a-default-rfid&fr:update',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/rfid-facerecognition'),
  },

  {
    path: '/master/identification/import/',
    name: 'Master RFID Import',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'd10a-default-rfid&fr:read',
            'd10a-default-rfid&fr:update',
            'd10a-default-rfid&fr:create',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/rfid-facerecognition/ImportPage'),
  },

  {
    path: '/master/identification/importresult/',
    name: 'Master RFID Import Result',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'd10a-default-rfid&fr:read',
            'd10a-default-rfid&fr:update',
            'd10a-default-rfid&fr:create',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/rfid-facerecognition/ImportResult'),
  },

  {
    path: '/master/rfid/history-tag/:id',
    name: 'Master RFID History Tag',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['z1k-rfid-md:read'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/master/rfid/history/history-tag'),
  },

  {
    path: '/master/rfid/:id',
    name: 'RFID Reader Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['z1k-rfid-md:read', 'z1k-rfid-md:update'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/rfid/form'),
  },

  {
    path: '/master/ibeacon/',
    name: 'Master Ibeacon',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'z1o-ibeacon-md:read',
          'z1o-ibeacon-md:update',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/ibeacon'),
  },

  {
    path: '/master/orthophoto/',
    name: 'Master Orthophoto',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['j1b-orthophoto-master-data:read'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/orthophoto'),
  },
  {
    path: '/master/ritage/',
    name: 'Master Ritage',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['j2a-ritage-master-data:read'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/ritage'),
  },
  {
    path: '/master/ritage/create',
    name: 'Master Ritage Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['j2a-ritage-master-data:create'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/ritage/form'),
  },
  {
    path: '/master/ritage/update/:id',
    name: 'Master Ritage Update',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['j2a-ritage-master-data:update'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/ritage/form'),
  },
  {
    path: '/master/rjm/',
    name: 'Master RJM',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['d9a-default-voice-announcer:read'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/rjm'),
  },
  {
    path: '/master/rjm/create/',
    name: 'Master RJM Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['d9a-default-voice-announcer:read'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/rjm/form'),
  },
  {
    path: '/master/rjm/update/:id',
    name: 'Master RJM Update',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['d9a-default-voice-announcer:read'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/master/rjm/form'),
  },
]
